import { factory, sequence } from 'stahlwerk';

export const createNotification = factory({
  id: sequence(),
  message: 'just a message',
  notificationType: 'type',
  isVisible: true,
});
